import { getETLComponentType } from './etl-component-types/factory';
import { augmentETLDryRunErrorObject } from './etl-component-types/utils';
import { TpETLPipeline, TpETLDryRun, TpETLDryRunError, TpETLDryRunObject, TpETLDataContext } from './interfaces';

export function generateEmptyETLDryRun(): TpETLDryRun {
  return {
    pipeline: null,
    objectsMap: {},
  } as any;
}

export function performDryRunETL(pipeline: TpETLPipeline, assetDataContext: TpETLDataContext | null): TpETLDryRun {
  const dryRun: TpETLDryRun = {
    pipeline,
    objectsMap: {},
    errors: [],
  };

  // We execute the components in the right order of the DAG, making sure are inputs are available before executing a component
  const executedComps: { [id: string]: boolean } = {};
  for (let runComplete = false; !runComplete; ) {
    runComplete = true;
    for (const comp of pipeline.components) {
      if (!executedComps[comp.id]) {
        const compType = getETLComponentType(comp.componentType);
        let isReadyForExecution = true;
        for (const inp of compType.inputs)
          if (!dryRun.objectsMap[comp.inputObjectIds[inp.id]]) isReadyForExecution = false;
        for (const param of comp.extraParamObjectIds) if (!dryRun.objectsMap[param]) isReadyForExecution = false;
        if (isReadyForExecution) {
          executedComps[comp.id] = true;
          runComplete = false;
          try {
            const compType = getETLComponentType(comp.componentType);
            compType.performDryRun(dryRun, comp, assetDataContext);
          } catch (error) {
            dryRun.errors.push(augmentETLDryRunErrorObject(error, comp.id, null));
          }
        }
      }
    }
  }

  // Sanity check: all components should have been executed
  for (const comp of pipeline.components)
    if (!executedComps[comp.id])
      dryRun.errors.push(augmentETLDryRunErrorObject('Could not execute component', comp.id, null));

  return dryRun;
}

export function addETLDryRunError(dryRun: TpETLDryRun, message: string, compId: string, paramId?: string) {
  dryRun.errors.push({
    message,
    compId,
    paramId,
  });
}

export function getETLDryRunObject(dryRun: TpETLDryRun, objId: string): TpETLDryRunObject {
  if (!dryRun.objectsMap[objId]) {
    debugger;
    throw `Missing object ${objId} in ETL pipeline`;
  }
  return dryRun.objectsMap[objId];
}

export function getDryRunErrorsForComponent(dryRun: TpETLDryRun, compId: string): TpETLDryRunError[] {
  return dryRun.errors.filter((error) => error.compId == compId);
}
